import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Wrapper, HeaderStyled, Logo, Navs} from './LightHeader.style';
import NavHeader from './NavHeader';

class LightHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.goHome = this.goHome.bind(this);
  }

  goHome() {
    const {history, restaurant, navUrls} = this.props;
    // redirect if its Add on
    if (restaurant.externalWebsiteUrl) {
      window.location = restaurant.externalWebsiteUrl;
    } else {
      history.push(navUrls.homeUrl);
    }
  }

  render() {
    const {restaurant, isOpen, navUrls} = this.props;
    return (
      <Wrapper data-rw="light-menu-header">
        <HeaderStyled data-rw="light-header">
          <Logo
            src={`${restaurant.imageLogoUrl}=h150`}
            onClick={this.goHome}
          />
          <Navs>
            <NavHeader
              name={restaurant.name}
              template={restaurant.template}
              modes={restaurant.modes}
              isOpen={isOpen}
              goHome={this.goHome}
              transparent={true}
              isAddOn={!!restaurant.externalWebsiteUrl}
              navUrls={navUrls}
            />
          </Navs>
        </HeaderStyled>
      </Wrapper>
    );
  }
}

LightHeader.propTypes = {
  restaurant: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  navUrls: PropTypes.object
};

export default withRouter(LightHeader);



// WEBPACK FOOTER //
// ./components/LightHeader/LightHeader.js